export const escapeHTMLString = (string: string) => {
  const doc = new DOMParser().parseFromString(string, "text/html");
  return doc.documentElement.textContent;
};
